import { Grid, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import React, { useEffect, useContext } from 'react';
import { getAllListData } from 'services/CommonServices';
import { EE_DASHBOARD, MASTER_ENDPOINT } from 'utils/Constant';
import PageLoader from 'components/PageLoader';
import _ from 'lodash';
import EmployeeDetailPopOut from 'components/EmployeeDetailPopOut';
import { FilterDataContext } from 'context/FilterDataContextProvider';

const statickParam: any = {
  sortBy: '',
  order: '',
  heading: '',
};

const EmployeeEngagementList = () => {
  const [loader, setLoader] = React.useState<boolean>(true);
  const [param, setParam] = React.useState<{
    sortBy: string;
    order: 'asc' | 'desc';
    heading: string;
  }>(statickParam);
  const [learningEmployeeList, setLearningEmployeeList] = React.useState<any>([]);
  const [clarityEmployeeList, setClarityEmployeeList] = React.useState<any>([]);
  const [safetyEmployeeList, setSafetyEmployeeList] = React.useState<any>([]);
  const [connectionEmployeeList, setConnectionEmployeeList] = React.useState<any>([]);
  const [actionEmployeeList, setActionEmployeeList] = React.useState<any>([]);
  const [adaptabilityEmployeeList, setAdaptabilityEmployeeList] = React.useState<any>([]);
  const [celebrationEmployeeList, setCelebrationEmployeeList] = React.useState<any>([]);
  const [drawer, setDrawer] = React.useState(false);
  const [details, setDetails] = React.useState<any>([]);
  const [moreDetails, setMoreDetails] = React.useState<any>([]);
  const [viewMoreDetails, setViewMoreDetails] = React.useState<any>({}); 
  const [loader1, setLoader1] = React.useState<boolean>(false);
  const [currentEmployeeID, setCurrentEmployeeId] = React.useState<any>(0);
  const wireUpClick = false;

  const {filterData} = useContext(FilterDataContext);

  const EmployeeList = () => {
    setLoader(true);
    getAllListData(`${EE_DASHBOARD.OrgList}`)
      .then((res) => {
        if (res?.data && res?.data?.length) {
          res?.data.filter((e: any) => {
            console.log(res?.data)
            if (e.value === 'Learning' && e.categoryGroupId ===2) {
              const employeeList = e?.employeeList;
              setLearningEmployeeList(employeeList);
            } else if (e.value === 'Clarity' && e.categoryGroupId ===2) {
              const employeeList = e?.employeeList;
              setClarityEmployeeList(employeeList);
            } else if (e.value === 'Safety' && e.categoryGroupId ===2) {
              const employeeList = e?.employeeList;
              setSafetyEmployeeList(employeeList);
            } else if (e.value === 'Connection' && e.categoryGroupId ===3) {
              const employeeList = e?.employeeList;
              setConnectionEmployeeList(employeeList);
            } else if (e.value === 'Action' && e.categoryGroupId ===4) {
              const employeeList = e?.employeeList;
              setActionEmployeeList(employeeList);
            } else if (e.value === 'Adaptability' && e.categoryGroupId ===4) {
              const employeeList = e?.employeeList;
              setAdaptabilityEmployeeList(employeeList);
            }
            else if (e.value === 'Celebration' && e.categoryGroupId ===4) {
              const employeeList = e?.employeeList;
              setCelebrationEmployeeList(employeeList);
            }
          });
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    EmployeeList();
    setViewMoreDetails({});
  }, [filterData]);

  useEffect(() =>{
    if(!drawer){
      setCurrentEmployeeId(0);
    }
  },[drawer])

  useEffect(() => {
    if(wireUpClick){
      const elements = document.querySelectorAll('.ename');
    
      elements.forEach(element => {
        element.addEventListener('click', employeeClick);
      }); 
    }
  }, [EmployeeList]); 

  const employeeClick = async (event: any) => {    
    const employeeId = event?.target?.value;

    if (employeeId != currentEmployeeID) {
      setCurrentEmployeeId(employeeId);
      setLoader(true); 
      setLoader1(true);  
      setDrawer(true); 
      const url = `${EE_DASHBOARD.ViewMore}/${employeeId}`;
      setLoader1(true);
      await getAllListData(url)
        .then((res) => {
          setDetails(res?.data);
        });

      const UrlM = `${EE_DASHBOARD.ViewMoreMagic}/${employeeId}`;
      await getAllListData(UrlM).then((res2) => {
        setMoreDetails(res2?.data);           
      }) 
      .finally(() => {
        setLoader(false); 
        setLoader1(false);           
       });                                 
    }
  }
  
  const changeParamLearning = (keyName: string, Heading: string) => {
    setLoader(true);
    setParam((pre: any) => {
      return {
        ...pre,
        sortBy: keyName,
        order:
          param.heading === Heading && param.sortBy === keyName && param.order === 'asc'
            ? 'desc'
            : 'asc',
        heading: Heading,
      };
    });
    setLearningEmployeeList([
      ..._.orderBy(
        learningEmployeeList,
        [
          (item: any) =>
            item[keyName]
              ? typeof item[keyName] === 'number'
                ? item[keyName]
                : item[keyName]?.toLowerCase()
              : '',
        ],
        param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      ),
    ]);
    setTimeout(() => setLoader(false), 500);
  };
  const changeParamClarity = (keyName: string, Heading: string) => {
    setLoader(true);
    setParam((pre: any) => {
      return {
        ...pre,
        sortBy: keyName,
        heading: Heading,
        order: param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      };
    });
    setClarityEmployeeList([
      ..._.orderBy(
        clarityEmployeeList,
        [
          (item: any) =>
            item[keyName]
              ? typeof item[keyName] === 'number'
                ? item[keyName]
                : item[keyName]?.toLowerCase()
              : '',
        ],
        param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      ),
    ]);
    setTimeout(() => setLoader(false), 500);
  };

  const changeParamSafety = (keyName: string, Heading: string) => {
    setLoader(true);
    setParam((pre: any) => {
      return {
        ...pre,
        sortBy: keyName,
        heading: Heading,
        order: param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      };
    });
    setSafetyEmployeeList([
      ..._.orderBy(
        safetyEmployeeList,
        [
          (item: any) =>
            item[keyName]
              ? typeof item[keyName] === 'number'
                ? item[keyName]
                : item[keyName]?.toLowerCase()
              : '',
        ],
        param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      ),
    ]);
    setTimeout(() => setLoader(false), 500);
  };

  const changeParamConnection = (keyName: string, Heading: string) => {
    setLoader(true);
    setParam((pre: any) => {
      return {
        ...pre,
        sortBy: keyName,
        heading: Heading,
        order: param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      };
    });
    setConnectionEmployeeList([
      ..._.orderBy(
        connectionEmployeeList,
        [
          (item: any) =>
            item[keyName]
              ? typeof item[keyName] === 'number'
                ? item[keyName]
                : item[keyName]?.toLowerCase()
              : '',
        ],
        param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      ),
    ]);
    setTimeout(() => setLoader(false), 500);
  };

  const changeParamCelebration = (keyName: string, Heading: string) => {
    setLoader(true);
    setParam((pre: any) => {
      return {
        ...pre,
        sortBy: keyName,
        heading: Heading,
        order: param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      };
    });
    setCelebrationEmployeeList([
      ..._.orderBy(
        celebrationEmployeeList,
        [
          (item: any) =>
            item[keyName]
              ? typeof item[keyName] === 'number'
                ? item[keyName]
                : item[keyName]?.toLowerCase()
              : '',
        ],
        param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      ),
    ]);
    setTimeout(() => setLoader(false), 500);
  };

  const changeParamAction = (keyName: string, Heading: string) => {
    setLoader(true);
    setParam((pre: any) => {
      return {
        ...pre,
        sortBy: keyName,
        heading: Heading,
        order: param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      };
    });
    setActionEmployeeList([
      ..._.orderBy(
        actionEmployeeList,
        [
          (item: any) =>
            item[keyName]
              ? typeof item[keyName] === 'number'
                ? item[keyName]
                : item[keyName]?.toLowerCase()
              : '',
        ],
        param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      ),
    ]);
    setTimeout(() => setLoader(false), 500);
  };
  const changeParamAdaptability = (keyName: string, Heading: string) => {
    setLoader(true);
    setParam((pre: any) => {
      return {
        ...pre,
        sortBy: keyName,
        heading: Heading,
        order: param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      };
    });
    setAdaptabilityEmployeeList([
      ..._.orderBy(
        adaptabilityEmployeeList,
        [
          (item: any) =>
            item[keyName]
              ? typeof item[keyName] === 'number'
                ? item[keyName]
                : item[keyName]?.toLowerCase()
              : '',
        ],
        param.sortBy === keyName && param.order === 'asc' ? 'desc' : 'asc',
      ),
    ]);
    setTimeout(() => setLoader(false), 500);
  };

  return (
    <Typography component={'div'} className='employee-table'>
      <PageLoader loading={loader} />
      <Typography component={'div'} className='d-flex-ja flex-column'>
          <EmployeeDetailPopOut loader1={loader1} 
                        setLoader1={setLoader1} 
                        drawer={drawer} 
                        details={details} 
                        viewMoreDetails={viewMoreDetails} 
                        moreDetails={moreDetails} 
                        setDrawer={setDrawer} 
                        setDetails={setDetails} 
                        setMoreDetails={setMoreDetails} ></EmployeeDetailPopOut>         
      </Typography>
      <Grid container>
        <Grid item md={1.6} sm={12} xs={12}>
          <Typography
            component={'div'}
            className='d-flex-a flex-sb h-69 border-right border-bottom'>
            <Typography className='th-title'>Learning</Typography>
            <Typography
              className='arrow-box'
              onClick={() => {
                // meaning changed has purpose
                changeParamLearning('score', 'Learning');
              }}>
              <ArrowDropDownIcon
                className='down'
                style={{
                  fill:
                    param.heading === 'Learning' &&
                    param.sortBy === 'score' &&
                    param.order === 'desc'
                      ? 'black'
                      : '',
                }}
              />
              <ArrowDropUpIcon
                className='up'
                style={{
                  fill:
                    param.heading === 'Learning' && param.sortBy === 'score' && param.order === 'asc'
                      ? 'black'
                      : '',
                }}
              />
            </Typography>
          </Typography>
        </Grid>
        <Grid item md={1.6} sm={12} xs={12}>
          <Typography
            component={'div'}
            className='d-flex-a flex-sb h-69 border-right border-bottom'>
            <Typography className='th-title'>Clarity</Typography>
            <Typography
              className='arrow-box'
              onClick={() => {
                // Autonomy has changed Independence
                changeParamClarity('score', 'Clarity');
              }}>
              <ArrowDropDownIcon
                className='down'
                style={{
                  fill:
                    param.heading === 'Clarity' &&
                    param.sortBy === 'score' &&
                    param.order === 'desc'
                      ? 'black'
                      : '',
                }}
              />
              <ArrowDropUpIcon
                className='up'
                style={{
                  fill:
                    param.heading === 'Clarity' &&
                    param.sortBy === 'score' &&
                    param.order === 'asc'
                      ? 'black'
                      : '',
                }}
              />
            </Typography>
          </Typography>
        </Grid>
        <Grid item md={1.6} sm={12} xs={12}>
          <Typography
            component={'div'}
            className='d-flex-a flex-sb h-69 border-right border-bottom'>
            <Typography className='th-title'>Safety</Typography>
            <Typography
              className='arrow-box'
              onClick={() => {
                changeParamSafety('score', 'Safety');
              }}>
              <ArrowDropDownIcon
                className='down'
                style={{
                  fill:
                    param.heading === 'Safety' && param.sortBy === 'score' && param.order === 'desc'
                      ? 'black'
                      : '',
                }}
              />
              <ArrowDropUpIcon
                className='up'
                style={{
                  fill:
                    param.heading === 'Safety' && param.sortBy === 'score' && param.order === 'asc'
                      ? 'black'
                      : '',
                }}
              />
            </Typography>
          </Typography>
        </Grid>
        <Grid item md={1.6} sm={12} xs={12}>
          <Typography
            component={'div'}
            className='d-flex-a flex-sb h-69 border-right border-bottom'>
            <Typography className='th-title'>Connection</Typography>
            <Typography
              className='arrow-box'
              onClick={() => {
                changeParamConnection('score', 'Connection');
              }}>
              <ArrowDropDownIcon
                className='down'
                style={{
                  fill:
                    param.heading === 'Connection' && param.sortBy === 'score' && param.order === 'desc'
                      ? 'black'
                      : '',
                }}
              />
              <ArrowDropUpIcon
                className='up'
                style={{
                  fill:
                    param.heading === 'Connection' && param.sortBy === 'score' && param.order === 'asc'
                      ? 'black'
                      : '',
                }}
              />
            </Typography>
          </Typography>
        </Grid>
        <Grid item md={1.6} sm={12} xs={12}>
          <Typography component={'div'} className='d-flex-a flex-sb h-69 border-bottom'>
            <Typography className='th-title'>Action</Typography>
            <Typography
              className='arrow-box'
              onClick={() => {
                // Connection has changed Relationship
                changeParamAction('score', 'Action');
              }}>
              <ArrowDropDownIcon
                className='down'
                style={{
                  fill:
                    param.heading === 'Action' &&
                    param.sortBy === 'score' &&
                    param.order === 'desc'
                      ? 'black'
                      : '',
                }}
              />
              <ArrowDropUpIcon
                className='up'
                style={{
                  fill:
                    param.heading === 'Action' &&
                    param.sortBy === 'score' &&
                    param.order === 'asc'
                      ? 'black'
                      : '',
                }}
              />
            </Typography>
          </Typography>
        </Grid>
        <Grid item md={1.6} sm={12} xs={12}>
          <Typography component={'div'} className='d-flex-a flex-sb h-69 border-bottom'>
            <Typography className='th-title'>Adaptability</Typography>
            <Typography
              className='arrow-box'
              onClick={() => {
                // Connection has changed Relationship
                changeParamAdaptability('score', 'Adaptability');
              }}>
              <ArrowDropDownIcon
                className='down'
                style={{
                  fill:
                    param.heading === 'Adaptability' &&
                    param.sortBy === 'score' &&
                    param.order === 'desc'
                      ? 'black'
                      : '',
                }}
              />
              <ArrowDropUpIcon
                className='up'
                style={{
                  fill:
                    param.heading === 'Adaptability' &&
                    param.sortBy === 'score' &&
                    param.order === 'asc'
                      ? 'black'
                      : '',
                }}
              />
            </Typography>
          </Typography>
        </Grid>
       <Grid item md={1.6} sm={12} xs={12}>
          <Typography component={'div'} className='d-flex-a flex-sb h-69 border-bottom'>
            <Typography className='th-title'>Celebration</Typography>
            <Typography
              className='arrow-box'
              onClick={() => {
                // Connection has changed Relationship
                changeParamCelebration('score', 'Celebration');
              }}>
              <ArrowDropDownIcon
                className='down'
                style={{
                  fill:
                    param.heading === 'Celebration' &&
                    param.sortBy === 'score' &&
                    param.order === 'desc'
                      ? 'black'
                      : '',
                }}
              />
              <ArrowDropUpIcon
                className='up'
                style={{
                  fill:
                    param.heading === 'Celebration' &&
                    param.sortBy === 'score' &&
                    param.order === 'asc'
                      ? 'black'
                      : '',
                }}
              />
            </Typography>
          </Typography>
        </Grid>
      </Grid>
      <Grid container className='body-content'>
        {!learningEmployeeList.length &&
        !clarityEmployeeList.length &&
        !safetyEmployeeList.length &&
        !connectionEmployeeList.length &&
        !actionEmployeeList.length  &&
        !adaptabilityEmployeeList.length &&
        !celebrationEmployeeList.length? (
          <Grid item md={12} sm={12} xs={12}>
            <Typography component={'div'} className='d-flex-ja norecord'>
              No Records Found
            </Typography>
          </Grid>
        ) : (
          <>
            <Grid item md={1.6} sm={12} xs={12}>
              <Grid container>
                {learningEmployeeList.map((row: any, i: number) => {
                  return (
                    <Grid md={12} sm={12} xs={12} key={i} item>
                      <Typography
                        component={'div'}
                        className={`${
                          row?.status === 'Needs Attention'
                            ? 'normal-box red-bg'
                            : row?.status === 'Good Standing'
                              ? 'normal-box blue-bg'
                              : row?.status === 'On the Move'
                                ? 'normal-box green-bg'
                                : 'normal-box'
                        }`}
                        // 'normal-box red-bg'
                      >
                        <Typography
                          className={`${
                            row?.status === 'Needs Attention'
                              ? 'redbar'
                              : row?.status === 'Good Standing'
                                ? 'bluebar'
                                : row?.status === 'On the Move'
                                  ? 'greenbar'
                                  : ''
                          }`}
                          // className='redbar'
                        />
                        <Typography className='count d-flex-ja'>{i + 1}</Typography>
                        <Typography component={'div'} className='d-flex-ja'>
                          {row?.userImageId ? (
                            <img
                              className='d-avtaor d-flex-ja'
                              src={`${process.env.REACT_APP_APIURL}${MASTER_ENDPOINT.GetImage}?getUserImageId=${row?.userImageId}`}
                            />
                          ) : (
                            <Typography className='d-avtaor d-flex-ja'>{`${row?.name?.charAt(
                              0,
                            )}`}</Typography>
                          )}
                        </Typography>
                        <Typography component={'div'} className='ml-8 d-flex-a flex-1'>
                          <Typography component={'div'} className='pr-8' sx={{ width: '80%' }}>
                          <Typography className='ename'><data value={row?.employeeId}>{row?.name}</data></Typography>
                          <Typography className='edep'>{row?.description}</Typography>
                          </Typography>
                          <Typography className='eval text-right flex-1'>{row.score}</Typography>
                        </Typography>
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item md={1.6} sm={12} xs={12}>
              <Grid container>
                {clarityEmployeeList.map((row: any, i: number) => {
                  return (
                    <Grid md={12} sm={12} xs={12} key={i} item>
                      <Typography
                        component={'div'}
                        className={`${
                          row?.status === 'Needs Attention'
                            ? 'normal-box red-bg'
                            : row?.status === 'Good Standing'
                              ? 'normal-box blue-bg'
                              : row?.status === 'On the Move'
                                ? 'normal-box green-bg'
                                : 'normal-box'
                        }`}>
                        <Typography
                          className={`${
                            row?.status === 'Needs Attention'
                              ? 'redbar'
                              : row?.status === 'Good Standing'
                                ? 'bluebar'
                                : row?.status === 'On the Move'
                                  ? 'greenbar'
                                  : ''
                          }`}
                          // className='redbar'
                        />
                        <Typography className='count d-flex-ja'>{i + 1}</Typography>
                        <Typography component={'div'} className='d-flex-ja'>
                          {row?.userImageId ? (
                            <img
                              className='d-avtaor d-flex-ja'
                              src={`${process.env.REACT_APP_APIURL}${MASTER_ENDPOINT.GetImage}?getUserImageId=${row?.userImageId}`}
                            />
                          ) : (
                            <Typography className='d-avtaor d-flex-ja'>{`${row?.name?.charAt(
                              0,
                            )}`}</Typography>
                          )}
                        </Typography>
                        <Typography component={'div'} className='ml-8 d-flex-a flex-1'>
                          <Typography component={'div'} className='pr-8' sx={{ width: '80%' }}>
                          <Typography className='ename'><data value={row?.employeeId}>{row?.name}</data></Typography>
                            <Typography className='edep'>{row?.description}</Typography>
                          </Typography>
                          <Typography className='eval text-right flex-1'>{row.score}</Typography>
                        </Typography>
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item md={1.6} sm={12} xs={12}>
              <Grid container>
                {safetyEmployeeList.map((row: any, i: number) => {
                  return (
                    <Grid md={12} sm={12} xs={12} key={i} item>
                      <Typography
                        component={'div'}
                        className={`${
                          row?.status === 'Needs Attention'
                            ? 'normal-box red-bg'
                            : row?.status === 'Good Standing'
                              ? 'normal-box blue-bg'
                              : row?.status === 'On the Move'
                                ? 'normal-box green-bg'
                                : 'normal-box'
                        }`}>
                        <Typography
                          className={`${
                            row?.status === 'Needs Attention'
                              ? 'redbar'
                              : row?.status === 'Good Standing'
                                ? 'bluebar'
                                : row?.status === 'On the Move'
                                  ? 'greenbar'
                                  : ''
                          }`}
                          // className='redbar'
                        />
                        <Typography className='count d-flex-ja'>{i + 1}</Typography>
                        <Typography component={'div'} className='d-flex-ja'>
                          {row?.userImageId ? (
                            <img
                              className='d-avtaor d-flex-ja'
                              src={`${process.env.REACT_APP_APIURL}${MASTER_ENDPOINT.GetImage}?getUserImageId=${row?.userImageId}`}
                            />
                          ) : (
                            <Typography className='d-avtaor d-flex-ja'>{`${row?.name?.charAt(
                              0,
                            )}`}</Typography>
                          )}
                        </Typography>
                        <Typography component={'div'} className='ml-8 d-flex-a flex-1 '>
                          <Typography component={'div'} className='pr-8' sx={{ width: '80%' }}>
                          <Typography className='ename'><data value={row?.employeeId}>{row?.name}</data></Typography>
                            <Typography className='edep'>{row?.description}</Typography>
                          </Typography>
                          <Typography className='eval text-right flex-1'>{row.score}</Typography>
                        </Typography>
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item md={1.6} sm={12} xs={12}>
              <Grid container>
                {connectionEmployeeList.map((row: any, i: number) => {
                  return (
                    <Grid md={12} sm={12} xs={12} key={i} item>
                      <Typography
                        component={'div'}
                        className={`${
                          row?.status === 'Needs Attention'
                            ? 'normal-box red-bg'
                            : row?.status === 'Good Standing'
                              ? 'normal-box blue-bg'
                              : row?.status === 'On the Move'
                                ? 'normal-box green-bg'
                                : 'normal-box'
                        }`}>
                        <Typography
                          className={`${
                            row?.status === 'Needs Attention'
                              ? 'redbar'
                              : row?.status === 'Good Standing'
                                ? 'bluebar'
                                : row?.status === 'On the Move'
                                  ? 'greenbar'
                                  : ''
                          }`}
                          // className='redbar'
                        />
                        <Typography className='count d-flex-ja'>{i + 1}</Typography>
                        <Typography component={'div'} className='d-flex-ja'>
                          {row?.userImageId ? (
                            <img
                              className='d-avtaor d-flex-ja'
                              src={`${process.env.REACT_APP_APIURL}${MASTER_ENDPOINT.GetImage}?getUserImageId=${row?.userImageId}`}
                            />
                          ) : (
                            <Typography className='d-avtaor d-flex-ja'>{`${row?.name?.charAt(
                              0,
                            )}`}</Typography>
                          )}
                        </Typography>
                        <Typography component={'div'} className='ml-8 d-flex-a flex-1'>
                          <Typography component={'div'} className='pr-8' sx={{ width: '80%' }}>
                          <Typography className='ename'><data value={row?.employeeId}>{row?.name}</data></Typography>
                            <Typography className='edep'>{row?.description}</Typography>
                          </Typography>
                          <Typography className='eval text-right flex-1'>{row.score}</Typography>
                        </Typography>
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item md={1.6} sm={12} xs={12}>
              <Grid container>
                {actionEmployeeList.map((row: any, i: number) => {
                  return (
                    <Grid md={12} sm={12} xs={12} key={i} item>
                      <Typography
                        component={'div'}
                        className={`${
                          row?.status === 'Needs Attention'
                            ? 'normal-box red-bg'
                            : row?.status === 'Good Standing'
                              ? 'normal-box blue-bg'
                              : row?.status === 'On the Move'
                                ? 'normal-box green-bg'
                                : 'normal-box'
                        }`}>
                        <Typography
                          className={`${
                            row?.status === 'Needs Attention'
                              ? 'redbar'
                              : row?.status === 'Good Standing'
                                ? 'bluebar'
                                : row?.status === 'On the Move'
                                  ? 'greenbar'
                                  : ''
                          }`}
                          // className='redbar'
                        />
                        <Typography className='count d-flex-ja'>{i + 1}</Typography>
                        <Typography component={'div'} className='d-flex-ja'>
                          {row?.userImageId ? (
                            <img
                              className='d-avtaor d-flex-ja'
                              src={`${process.env.REACT_APP_APIURL}${MASTER_ENDPOINT.GetImage}?getUserImageId=${row?.userImageId}`}
                            />
                          ) : (
                            <Typography className='d-avtaor d-flex-ja'>{`${row?.name?.charAt(
                              0,
                            )}`}</Typography>
                          )}
                        </Typography>
                        <Typography component={'div'} className='ml-8 d-flex-a flex-1'>
                          <Typography component={'div'} className='pr-8' sx={{ width: '80%' }}>
                          <Typography className='ename'><data value={row?.employeeId}>{row?.name}</data></Typography>
                            <Typography className='edep'>{row?.description}</Typography>
                          </Typography>
                          <Typography className='eval text-right flex-1'>{row.score}</Typography>
                        </Typography>
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item md={1.6} sm={12} xs={12}>
              <Grid container>
                {adaptabilityEmployeeList.map((row: any, i: number) => {
                  return (
                    <Grid md={12} sm={12} xs={12} key={i} item>
                      <Typography
                        component={'div'}
                        className={`${
                          row?.status === 'Needs Attention'
                            ? 'normal-box red-bg'
                            : row?.status === 'Good Standing'
                              ? 'normal-box blue-bg'
                              : row?.status === 'On the Move'
                                ? 'normal-box green-bg'
                                : 'normal-box'
                        }`}>
                        <Typography
                          className={`${
                            row?.status === 'Needs Attention'
                              ? 'redbar'
                              : row?.status === 'Good Standing'
                                ? 'bluebar'
                                : row?.status === 'On the Move'
                                  ? 'greenbar'
                                  : ''
                          }`}
                          // className='redbar'
                        />
                        <Typography className='count d-flex-ja'>{i + 1}</Typography>
                        <Typography component={'div'} className='d-flex-ja'>
                          {row?.userImageId ? (
                            <img
                              className='d-avtaor d-flex-ja'
                              src={`${process.env.REACT_APP_APIURL}${MASTER_ENDPOINT.GetImage}?getUserImageId=${row?.userImageId}`}
                            />
                          ) : (
                            <Typography className='d-avtaor d-flex-ja' >{`${row?.name?.charAt(
                              0,
                            )}`}</Typography>
                          )}
                        </Typography>
                        <Typography component={'div'} className='ml-8 d-flex-a flex-1'>
                          <Typography component={'div'} className='pr-8' sx={{ width: '80%' }}>
                          <Typography className='ename'><data value={row?.employeeId}>{row?.name}</data></Typography>
                            <Typography className='edep'>{row?.description}</Typography>
                          </Typography>
                          <Typography className='eval text-right flex-1'>{row.score}</Typography>
                        </Typography>
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item md={1.6} sm={12} xs={12}>
              <Grid container>
                {celebrationEmployeeList.map((row: any, i: number) => {
                  return (
                    <Grid md={12} sm={12} xs={12} key={i} item>
                      <Typography
                        component={'div'}
                        className={`${
                          row?.status === 'Needs Attention'
                            ? 'normal-box red-bg'
                            : row?.status === 'Good Standing'
                              ? 'normal-box blue-bg'
                              : row?.status === 'On the Move'
                                ? 'normal-box green-bg'
                                : 'normal-box'
                        }`}>
                        <Typography
                          className={`${
                            row?.status === 'Needs Attention'
                              ? 'redbar'
                              : row?.status === 'Good Standing'
                                ? 'bluebar'
                                : row?.status === 'On the Move'
                                  ? 'greenbar'
                                  : ''
                          }`}
                          // className='redbar'
                        />
                        <Typography className='count d-flex-ja'>{i + 1}</Typography>
                        <Typography component={'div'} className='d-flex-ja'>
                          {row?.userImageId ? (
                            <img
                              className='d-avtaor d-flex-ja'
                              src={`${process.env.REACT_APP_APIURL}${MASTER_ENDPOINT.GetImage}?getUserImageId=${row?.userImageId}`}
                            />
                          ) : (
                            <Typography className='d-avtaor d-flex-ja' >{`${row?.name?.charAt(
                              0,
                            )}`}</Typography>
                          )}
                        </Typography>
                        <Typography component={'div'} className='ml-8 d-flex-a flex-1'>
                          <Typography component={'div'} className='pr-8' sx={{ width: '80%' }}>
                          <Typography className='ename'><data value={row?.employeeId}>{row?.name}</data></Typography>
                            <Typography className='edep'>{row?.description}</Typography>
                          </Typography>
                          <Typography className='eval text-right flex-1'>{row.score}</Typography>
                        </Typography>
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </>
        )}
        {}
      </Grid>
    </Typography>
  );
};

export default EmployeeEngagementList;
